// Actions/types.ts
import { FilterModel } from 'ag-grid-community';
import { GridRef } from 'src/components/pages/ControlSummaryPageAGGrid';
import { ForwardedRef } from 'react';
import { FilterOption, RecordAttributes } from '@amzn/controllershiphub-typescript-client';

export interface FilterViewManagerProps {
  controlId: string;
  filters: Record<string, string[]>;
  agGridFilters: FilterModel;
  displayNameMapping: Record<string, string>;
  onViewSelect: (filters: Record<string, string[]>, agGridFilters: FilterModel) => void;
  gridRef: ForwardedRef<GridRef>;
  onLoadMore?: () => void;
  hasMoreData?: boolean;
  isLoadingMore?: boolean;
  onExportData?: () => void;
  dataType?: string;
}

export interface FilterState {
  filters: Record<string, string[]>;
  activeFilters: Record<string, string[]>;
  agGridFilters: any;
  distinctValues: Record<string, string[]>;
  defaultFilterOptions: Record<string, FilterOption>;
}

export interface FilterActions {
  setFilters: (filters: Record<string, string[]>) => void;
  setActiveFilters: (filters: Record<string, string[]>) => void;
  setAgGridFilters: (filters: any) => void;
  setDistinctValues: React.Dispatch<React.SetStateAction<Record<string, string[]>>>;
  fetchData: (filters: Record<string, string[]>) => Promise<void>;
}

export interface FilterUIState {
  setIsLoading: (loading: boolean) => void;
  setHasFilterChanges: (hasChanges: boolean) => void;
  setFiltersApplied: (applied: boolean) => void;
}

export interface ClearFiltersParams {
  state: FilterState;
  actions: FilterActions;
  uiState: FilterUIState;
  gridRef: ForwardedRef<GridRef>;
  dataCache: Map<string, RecordAttributes[][]>;
}

export interface ApplyFiltersParams {
  currentFilters: Record<string, string[]>;
  actions: FilterActions;
  uiState: FilterUIState;
  gridRef: ForwardedRef<GridRef>;
}

export const DEFAULT_VIEW = 'Default View' as const;
